const state = {
 reload_default_client_ts_auth: false,
 
 create_login_modal: false,
 view_login_modal: false,
 create_login_contact: null,
 create_login_contact_level: null,
 view_login_contact: null,

};

const actions = {};

const mutations = {
 RELOAD_DEFAULT_CLIENT_TS_AUTH(state, payload) {
  state.reload_default_client_ts_auth = payload.action;
 },
 SHOW_CREATE_CONTACT_LOGIN_MODAL(state, payload) {
  state.create_login_modal = true;
  state.view_login_modal = false;
  state.create_login_contact = payload.contact;
  state.create_login_contact_level = payload.contact_level
 },
 SHOW_VIEW_CONTACT_LOGIN_MODAL(state, payload) {
  state.view_login_modal = true;
  state.create_login_modal = false;
  state.view_login_contact = payload.contact;
 },
 HIDE_CONTACT_LOGIN_MODALS(state) {
  state.create_login_modal = false;
  state.view_login_modal = false;
  state.create_login_contact = null;
  state.create_login_contact_level = null;
  state.view_login_contact = null;
 }
};
export default {
 state,
 actions,
 mutations
}
